import type { GlobalState } from '../index';
import type { IState } from '../reducers/metadata';

export const getMetadata = (state: GlobalState): IState['data'] => state.metadata.data;
